export enum SearchPageStateEnum {
  loading = 'loading',
  create_contact = 'create_contact',
  results = 'results',
  recent_searches = 'recent_searches',
  empty_state = 'empty_state',
}
